import { FC, ReactNode } from "react";

const IconButton: FC<{
    children: ReactNode,
    onClick?: VoidFunction,
    size?: number,
    disableSize?: boolean,
    className?: string,
    title?: string,
}> = ({ children, size = 6, onClick, className, disableSize = false, title }) => {
    return <button title={title} className={`rounded-md p-2 hover:bg-info/50 text-text transition-a;; duration-300 cursor-pointer dark:text-dark-text ${className}`} onClick={(e) => {
        e.stopPropagation();
        onClick?.();
    }}>
        <div className={disableSize ? '' : `size-${size}`}>
            {children}
        </div>
    </button>
}

export default IconButton;